import { onSendErrorFeedback } from 'hybridspace-graphql/lib/utils/useManagedQueryWithError';
import { renderOCVFeedbackPanel } from 'accelerator-ocv';
import { getLogicalRing } from 'owa-config';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { orchestrator } from 'satcheljs';
import renderFeedbackPanel from './FeedbackPanel';

orchestrator(onSendErrorFeedback, ({ errorState }) => {
    const isSdfUser = getLogicalRing() === 'Dogfood';
    const isOCVEnabled = !isSdfUser || isGlobalFeatureEnabled('msplaces-dev-OCVFeedback');
    isOCVEnabled ? renderOCVFeedbackPanel() : renderFeedbackPanel(errorState);
});
